// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import { Tabbar,TabbarItem ,Collapse,CollapseItem,DatetimePicker,Picker,Popup,Field,Button,NoticeBar,NavBar,Toast,Tab,Tabs,Checkbox,CheckboxGroup,Cell,CellGroup,Icon,Switch } from 'vant';
import ip from './api/config.js';
import './style/reset.css';
import './style/border.css';
import 'vant/lib/index.css';
Vue.use(Tabbar).use(TabbarItem);
Vue.use(Collapse).use(CollapseItem);
Vue.use(DatetimePicker);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Button);
Vue.use(NoticeBar);
Vue.use(NavBar);
Vue.use(Toast);
Vue.use(Tab).use(Tabs);
Vue.use(Checkbox).use(CheckboxGroup);
Vue.use(Cell).use(CellGroup);
Vue.use(Icon);
Vue.use(Switch);
Vue.prototype.apiIp=ip;

Vue.config.productionTip = false;
/* eslint-disable no-new */


router.beforeEach((to, from, next) => {
    /*let local=localStorage.getItem('user');
    if(local === null){
        if(to.path === '/' && to.name === 'Login'){
            next();
        }else if(to.path === '/Login'){
            next()
        }
    }else{
        if(to.path === '/'){
            next({path:'/RealTime'})
        }else{
            next()
        }
    }*/
    next()
});

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js